import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';

export default function removeUnusedValues(polyMesh, withLogging) {

  const l = withLogging || false;

  const faceValueIndices = new Uint32Array(polyMesh.positions.faceValueIndices);
  const values = polyMesh.positions.values;

  const newValues = new ObjectArrayView(THREE.Vector3, values.length);

  const valueMappings = new Map();
  let newValuesLength = 0;

  let newIndex = 0;
  const value = new THREE.Vector3;

  for (let i = 0; i < faceValueIndices.length; i++) {
    if (!valueMappings.has(faceValueIndices[i])) {
      valueMappings.set(faceValueIndices[i], newValuesLength);
      newIndex = newValuesLength;
      values.getAt(faceValueIndices[i], value);
      newValues.setAt(newValuesLength, value);
      newValuesLength++;
    } else {
      newIndex = valueMappings.get(faceValueIndices[i]);
    }

    faceValueIndices[i] = newIndex;

  }

  if (l) console.log('' + values.length + ' values reduced to ' + newValuesLength + ', unused values removed: ' + (values.length - newValuesLength));

  if (values.length === newValuesLength) return polyMesh;

  const newValuesArray = new ObjectArrayView(THREE.Vector3, newValuesLength);
  newValuesArray.fromArray(newValues.toArray());

  const newPositions = new PolyMap({
    faceRangeOffsets: polyMesh.faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: newValuesArray,
  });

  const resultMesh = new PolyMesh(polyMesh);
  resultMesh.positions = newPositions;

  return resultMesh;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/removeUnusedValues.js